import { FormModal } from './modules/Modal';
import { PoolSearchAreaMap } from './Forms/PoolSearchAreaMap.ts';
import { FallbackLocationFilter } from './Forms/FallbackLocationFilter';
import type { ExistingLocationFilter } from './Forms/LocationFilterBase';

let map: PoolSearchAreaMap | null = null;
let fallback: FallbackLocationFilter | null = null;
let mapKitInitialized = false;

let cachedForm: HTMLFormElement | null = null;
let cachedMapContainer: HTMLDivElement | null = null;
let cachedExistingFilter: ExistingLocationFilter = null;

window.addEventListener(window.MapKitInitialized.type, () => {
    mapKitInitialized = true;

    if (!map && cachedForm && cachedMapContainer) {
        map = new PoolSearchAreaMap(cachedForm, cachedMapContainer, cachedExistingFilter);
    }
});

const openModalButton = document.querySelector<HTMLButtonElement>('#open-filter-modal');

if (openModalButton) {
    openModalButton.addEventListener('click', (event) => {
        const target = event?.target as HTMLButtonElement;
        const modalTitle = target?.dataset?.modalTitle || '';
        const formContainer = document.querySelector<HTMLElement>(
            `#${target.dataset.formContainer}`
        );
        const form = formContainer?.querySelector<HTMLFormElement>('form');
        const mapContainer = document.querySelector<HTMLDivElement>('#pool-filter-map');
        const filterFormModal = new FormModal(modalTitle, event);
        filterFormModal.open();

        if (!form || !mapContainer) {
            return;
        }

        const isAuthenticated = form.dataset.authenticated === 'true';

        const filterUrl = new URL(document.location.href);
        const searchParamName = form.dataset?.searchParamName || '';
        const existingFilterAsJSON = filterUrl.searchParams.get(searchParamName);
        const existingFilter: ExistingLocationFilter = existingFilterAsJSON
            ? JSON.parse(existingFilterAsJSON)
            : null;

        cachedForm = form;
        cachedMapContainer = mapContainer;
        cachedExistingFilter = existingFilter;

        if (mapKitInitialized) {
            if (!map) {
                map = new PoolSearchAreaMap(form, mapContainer, existingFilter);
            }
        } else if (isAuthenticated) {
            if (!fallback) {
                fallback = new FallbackLocationFilter(form, existingFilter);
            }
        }
    });
}
